if(window.innerWidth>750){
    new Swiper('.banner3Swiper', {
        slidesPerView:5,
        autoplay:{
            disableOnInteraction: false,
        }
    })
}else{
    new Swiper('.banner3Swiper', {
        slidesPerView:1.5,
        centeredSlides: true,
        autoplay:{
            disableOnInteraction: false,
        }
    })
}

$('.box2_btn div').click(function(){
    var index = $(this).index()+1
    $('.box2_btn div').css({background:'transparent',color:'black',border:'1px solid black'})
    $(this).css({background:'red',color:'white',border:'1px solid red'})
    $('.box2Btn').hide()
    $(`.box2_content .box2Btn:nth-child(${index})`).show()
})


// 初始化地图函数 
let map;
async function initMap() {
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    var icon = {
        url:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/sign-icon_0945ac69-03ec-426b-8626-91ef50c3c31b.svg?v=1711012564',
        scaledSize: new google.maps.Size(30, 30)
    }
    map = new Map(document.getElementById("map"), {
        center: { lat: 40.7128, lng: -74.0060 },
        zoom: 3,
        language: 'en',
        mapId:'409b669a5958ac0c'
    });

    // 国家经纬度来自谷歌地图 map.google.com

    //阿拉伯联合酋长国
    new google.maps.Marker({
        position: {lat: 23.798838461886287, lng: 54.11941164990848},
        map,
        icon:icon
    });

    //埃及
    new google.maps.Marker({
        position: {lat: 26.611281377902543, lng: 29.65182283400884},
        map: map,
        icon:icon
    });

    //澳大利亚
    new google.maps.Marker({
        position: {lat: -24.971725878951844, lng: 135.26588372437067},
        map: map,
        icon:icon
    });

    //巴基斯坦
    new google.maps.Marker({
        position: {lat: 30.009450580262207, lng: 69.5090433110305},
        map: map,
        icon:icon
    });

    //巴拉圭
    new google.maps.Marker({
        position: {lat: -23.233405047559543, lng: -58.3992674704531},
        map: map,
        icon:icon
    });

    //巴林
    new google.maps.Marker({
        position: {lat: 26.038096060048808, lng:50.52709741017037},
        map: map,
        icon:icon
    });

    //巴西
    new google.maps.Marker({
        position: {lat: -8.76487208970325, lng:-56.28807063302951},
        map: map,
        icon:icon
    });

    //波兰
    new google.maps.Marker({
        position: {lat: 52.90920821982616, lng:18.75918493669949},
        map: map,
        icon:icon
    });

    //德国
    new google.maps.Marker({
        position: {lat: 51.0568898361367, lng:10.362338215868864},
        map: map,
        icon:icon
    });

    //多米尼加共和国
    new google.maps.Marker({
        position: {lat:18.90452048884448, lng:-70.15299735795082},
        map: map,
        icon:icon
    });

    //俄罗斯  
    new google.maps.Marker({
        position: {lat:61.92874041300932, lng:95.04499406916207},
        map: map,
        icon:icon
    });

    //法国   
    new google.maps.Marker({
        position: {lat:46.59625477944357, lng:2.3206586082179825},
        map: map,
        icon:icon
    });

    //菲律宾    
    new google.maps.Marker({
        position: {lat:12.594548300247364, lng:122.6883788126943},
        map: map,
        icon:icon
    });

    //哥伦比亚    
    new google.maps.Marker({
        position: {lat:3.3237142386439524, lng:-72.78852125903764},
        map: map,
        icon:icon
    });

    //韩国     
    new google.maps.Marker({
        position: {lat:36.55289249218539, lng:127.77132259485451},
        map: map,
        icon:icon
    });

    //荷兰  
    new google.maps.Marker({
        position: {lat:52.16185698924019, lng:5.663381947552627},
        map: map,
        icon:icon
    });

    //加拿大   
    new google.maps.Marker({
        position: {lat:57.73530061563072, lng:-102.3407688930933},
        map: map,
        icon:icon
    });

    //捷克共和国    
    new google.maps.Marker({
        position: {lat:49.7182074910196, lng:15.177729253219072},
        map: map,
        icon:icon
    });

    //科威特     
    new google.maps.Marker({
        position: {lat:29.302873185378168, lng:47.43830917800559},
        map: map,
        icon:icon
    });

    //黎巴嫩      
    new google.maps.Marker({
        position: {lat:34.22680998340739, lng:35.937847274967496},
        map: map,
        icon:icon 
    });

    //利比亚       
    new google.maps.Marker({
        position: {lat:26.970180070104817, lng:17.247369254798894},
        map: map,
        icon:icon 
    });

    //马尔代夫
    new google.maps.Marker({
        position: {lat:-0.6469778133155186, lng:72.65347089382354},
        map: map,
        icon:icon 
    });

    //马来西亚 
    new google.maps.Marker({
        position: {lat:3.7723244936393745, lng:102.34495532475063},
        map: map,
        icon:icon 
    });

    //美国 
    new google.maps.Marker({
        position: {lat:40.055571931951754, lng:-102.05023815036473},
        map: map,
        icon:icon 
    });

    //缅甸  
    new google.maps.Marker({
        position: {lat:21.338065865719354, lng:96.43949461887198},
        map: map,
        icon:icon 
    });

    //墨西哥 
    new google.maps.Marker({
        position: {lat:23.837433119402395, lng:-102.79676302149653},
        map: map,
        icon:icon 
    });

    //南非  
    new google.maps.Marker({
        position: {lat:-31.022682469675818, lng:24.2144507818543},
        map: map,
        icon:icon 
    });

    //挪威  
    new google.maps.Marker({
        position: {lat:61.933425604955794, lng:9.724375452286605},
        map: map,
        icon:icon 
    });

    //日本  
    new google.maps.Marker({
        position: {lat:36.582210504496864, lng:138.41474995144029},
        map: map,
        icon:icon 
    });

    //瑞典   
    new google.maps.Marker({
        position: {lat:62.858181428268985, lng:16.372033256943972},
        map: map,
        icon:icon 
    });

    //瑞士   
    new google.maps.Marker({
        position: {lat:46.77928597523484, lng:8.025852038377037},
        map: map,
        icon:icon 
    });

    //塞尔维亚    
    new google.maps.Marker({
        position: {lat:44.117329566927616, lng:20.754271764947166},
        map: map,
        icon:icon 
    });

    //沙特阿拉伯    
    new google.maps.Marker({
        position: {lat:23.568062933402107, lng:45.07845682589235},
        map: map,
        icon:icon 
    });

    //泰国     
    new google.maps.Marker({
        position: {lat:15.413435699389156, lng:101.00768531984309},
        map: map,
        icon:icon 
    });

    //乌克兰      
    new google.maps.Marker({
        position: {lat:49.02845651023894, lng:31.264869314053392},
        map: map,
        icon:icon 
    });

    //西班牙      
    new google.maps.Marker({
        position: {lat:39.34307046117709, lng:-3.461202755540108},
        map: map,
        icon:icon 
    });

    //希腊     
    new google.maps.Marker({
        position: {lat:39.460691377483904, lng:22.563712043113703},
        map: map,
        icon:icon 
    });

    //新西兰     
    new google.maps.Marker({
        position: {lat:-42.90132128456697, lng:171.9023773206581},
        map: map,
        icon:icon 
    });

    //伊拉克      
    new google.maps.Marker({
        position: {lat:32.93525007455012, lng:43.13979369052788},
        map: map,
        icon:icon 
    });

    //伊朗       
    new google.maps.Marker({
        position: {lat:32.0725110621044, lng:54.262556359424636},
        map: map,
        icon:icon 
    });

    var country = getCookie('user_country')
    if(country && country == 'IL'){
        $('.bcmi1').hide()
        $('.bcmi2').show()
        //以色列        
        new google.maps.Marker({
            position: {lat:31.02365396387719, lng:34.81181344289549},
            map: map,
            icon:icon 
        });
    }
    
    

    //印度尼西亚        
    new google.maps.Marker({
        position: {lat:-4.377288773166987, lng:122.68992608420864},
        map: map,
        icon:icon 
    });

    //英国         
    new google.maps.Marker({
        position: {lat:54.88200366084675, lng:-2.694811181290624},
        map: map,
        icon:icon 
    });

    //约旦          
    new google.maps.Marker({
        position: {lat:31.2214883455478, lng:36.83065066786153},
        map: map,
        icon:icon 
    });

    //越南           
    new google.maps.Marker({
        position: {lat:14.457080682064593, lng:108.2409956250018},
        map: map,
        icon:icon 
    });

    //智利           
    new google.maps.Marker({
        position: {lat:-27.022766236162237, lng:-70.31823105931412},
        map: map,
        icon:icon 
    });

    //中国           
    new google.maps.Marker({
        position: {lat:34.82331921499875, lng:103.40119658014356},
        map: map,
        icon:icon 
    });

    //格鲁吉亚            
    new google.maps.Marker({
        position: {lat:42.17507219104796, lng:43.45036486652576},
        map: map,
        icon:icon 
    });

    //爱尔兰             
    new google.maps.Marker({
        position: {lat:53.18347677153659, lng:-8.230258584469093},
        map: map,
        icon:icon 
    });

    //也门阿拉伯共合国              
    new google.maps.Marker({
        position: {lat:15.816959792991739, lng:47.634713558007896},
        map: map,
        icon:icon 
    });

    //保加利亚  
    new google.maps.Marker({
        position: {lat:42.49544070613287, lng:25.180051618306162},
        map: map,
        icon:icon 
    });
}
initMap();